import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"

import "assets/css/bootstrap.min.css"
import "assets/scss/style.scss"
import "assets/main/main.css"
import "assets/main/nucleo-icons-page-styles.css"

import Index from "./views/Index";
import Project from "./views/sections/Project";
import Admin from "./views/sections/Admin"


import ScrollToTop from "./ScrollToTop"
const app = (
  
  <BrowserRouter>
    <ScrollToTop />
      <Switch>
        <Route path="/index" render={props => <Index {...props} />} />
        <Route
          path="/project/:id"
          render={props => <Project {...props} />}
        />
        <Route
          path="/admin"
          render={props => <Admin {...props} />}
        />
        <Redirect to="/index" />
        <Redirect from="/" to="/index" />
      </Switch>
  </BrowserRouter>
)

ReactDOM.render(app, document.getElementById("root"))
